import Skeleton from 'react-loading-skeleton'
import { HorizontalCardDescription } from '@velasca/ui/horizontal-card-description'
import {
  Details,
  Images,
  Product,
  ProductImageSkeleton,
  ProductType,
  Spacer,
  Title,
} from '../QuickAdd.styles'

export const QuickAddSkeleton = () => (
  <Product>
    <Images>
      <ProductImageSkeleton />
    </Images>
    <Details>
      <Title>
        <Skeleton width="14rem" />
      </Title>
      <ProductType>
        <Skeleton width="9rem" />
      </ProductType>
      <Spacer>
        <HorizontalCardDescription>
          <Skeleton width="19rem" />
        </HorizontalCardDescription>
      </Spacer>
      <HorizontalCardDescription>
        <Skeleton width="19rem" />
      </HorizontalCardDescription>
      <Skeleton width="4rem" />
      <Skeleton width="6rem" />
    </Details>
  </Product>
)
